/**
 * Central design tokens — JS-side mirror of the CSS custom
 * properties defined in src/css/variables.css. Use this when a
 * React component needs a token value at runtime (a framer-motion
 * animation duration, a Canvas fill, a PNG share card). CSS
 * components should keep reading the CSS variables directly.
 *
 * Kept small on purpose — only the tokens components actually
 * reach for from JS. Anything CSS-only lives in variables.css.
 */

export const DUR = {
  short: 180,
  med:   320,
  long:  540,
};

export const EASE = {
  standard: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
  spring:   'cubic-bezier(0.34, 1.36, 0.64, 1)',
};

export const SHADOW = {
  subtle:  '0 1px 2px rgba(45, 31, 38, 0.05)',
  card:    '0 1px 2px rgba(45, 31, 38, 0.05), 0 10px 24px -16px rgba(45, 31, 38, 0.18)',
  overlay: '0 24px 60px -20px rgba(45, 31, 38, 0.45)',
};

export const RADIUS = {
  sm:    8,
  md:    12,
  lg:    16,
  xl:    20,
  pill:  999,
};

export const SPACING = {
  xs:  4,
  sm:  8,
  md:  12,
  lg:  16,
  xl:  20,
  xxl: 24,
  xxxl: 32,
  xxxxl: 48,
};

export const INK_ON = {
  sage:  '#4a5f44',
  gold:  '#6c5024',
  mauve: '#6b3849',
  rose:  '#6b5560',
};
